/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { connect } from 'react-redux'
import {
  mapStateToProps,
  memoMapExternalMsgBtnDispatchToProps,
} from './ExternalMessageButtonContainer'
import { ExternalMessageButtonTest } from './ExternalMessageButtonTest'

export const ExternalMessageButtonContainer = connect(
  mapStateToProps,
  memoMapExternalMsgBtnDispatchToProps,
  null,
  { forwardRef: true }
)(ExternalMessageButtonTest)
